// Following guide from https://stackoverflow.com/a/61188946

import type { ReactNode } from 'react'
import { createIntl, createIntlCache } from 'react-intl'
import type { IntlCache, IntlShape } from 'react-intl'
import type { IntlConfig } from '@formatjs/intl'

import defaultMessages from './en.json'

let cache: IntlCache | null = null

// eslint-disable-next-line import-x/no-mutable-exports
let intl: IntlShape

const loadMessages = async (locale: string) => {
  switch (locale) {
    case 'cs':
      return (await import('./cs.json')).default
    case 'da':
      return (await import('./da.json')).default
    case 'de':
      return (await import('./de.json')).default
    case 'es':
      return (await import('./es.json')).default
    case 'fi':
      return (await import('./fi.json')).default
    case 'fr':
      return (await import('./fr.json')).default
    case 'hu':
      return (await import('./hu.json')).default
    case 'it':
      return (await import('./it.json')).default
    case 'ja':
      return (await import('./ja.json')).default
    case 'ko':
      return (await import('./ko.json')).default
    case 'lt':
      return (await import('./lt.json')).default
    case 'no':
      return (await import('./no.json')).default
    case 'nl':
      return (await import('./nl.json')).default
    case 'pl':
      return (await import('./pl.json')).default
    case 'pt':
      return (await import('./pt.json')).default
    case 'ru':
      return (await import('./ru.json')).default
    case 'sv':
      return (await import('./sv.json')).default
    case 'tr':
      return (await import('./tr.json')).default
    case 'vi':
      return (await import('./vi.json')).default
    case 'zh-Hans':
      return (await import('./zh-Hans.json')).default
    case 'zh-Hant':
      return (await import('./zh-Hant.json')).default
    default:
      return Promise.resolve(defaultMessages)
  }
}

/** Generate IntlShape object */
function generateIntl(config: IntlConfig<ReactNode>): IntlShape {
  if (cache !== null) {
    cache = null
  }

  cache = createIntlCache()

  intl = createIntl(config, cache)

  return intl
}

export { generateIntl, intl, loadMessages, defaultMessages }
